import { Col, Row } from "react-bootstrap";
import AdminLayout from "./layout/AdminLayout";
import WorkForceList from "../components/admin/workforce/WorkForceList";
import RecentWorkForce from "../components/admin/workforce/RecentWorkForce";
import UcrtList from "../components/admin/ucrt/UcrtList";
const UcrtModule = () => {
  return (
    <AdminLayout>
      <Row>
        {/* <h1 className="title mb-4">Dashboard</h1> */}
        {/* <Col className="container mb-4">
          <RecentWorkForce/>
          
        </Col> */}
        <Col className="container mb-4">
        <UcrtList  />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default UcrtModule;
